export default __webpack_public_path__ + "static/weStillDream-348ad651c02b77c5d7fbb25480c9f737.jpeg";